export const twoDPRegex = RegExp(/^\d+(\.\d{1,2})?$/);
